import { render, staticRenderFns } from "./PrintSticker.vue?vue&type=template&id=4604b34a&"
import script from "./PrintSticker.vue?vue&type=script&lang=js&"
export * from "./PrintSticker.vue?vue&type=script&lang=js&"
import style0 from "./PrintSticker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports